import React, { Fragment } from 'react';
import PropTypes from "prop-types";
import './input.css';
import { generateRandomString } from 'helpers/helper';

const TextBox = (props) => {
  const {width, height, spellCheck, label} = {width:80, height:10, spellCheck:false, ...props};
  let id = props.id;

  if(id === undefined || !id) {
    id=generateRandomString(10);
  }
  const onChange = (e) => {
    props.onChange(e.target.value);
  }

  let stateClassName='';
  let msg;

  if(props.info) {
    stateClassName='info';
    msg=props.info;
  }

  if(props.error) {
    stateClassName='error';
    msg=props.error;
  } 

  return ( 
    <Fragment>
      {
        label && 
          <label for={id} className='w-full inline-block font-bold font-xl'>
            {label}
          </label>
      }
      <div className={`relative ${props.className} border border-1 border-uhblue rounded`}>
        <textarea 
          id={id}
          rows={height} 
          cols={width} 
          spellCheck={spellCheck} 
          name={props.name} 
          onChange={onChange}
          value={props.content}
          className=' px-2 py-1 w-full outline-none'
          onFocus={props.onFocus}
          placeholder={props.placeholder}
        />
        <div className={`inputMsg ${stateClassName}`}>
          {msg}
        </div>
      </div>
    </Fragment>
    
      
      
  ) 
}

TextBox.propTypes = {
  name: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default TextBox;